var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 14.6875C24.375 15.205 23.955 15.625 23.4375 15.625H15.625V23.4375C15.625 23.955 15.205 24.375 14.6875 24.375C14.17 24.375 13.75 23.955 13.75 23.4375V15.625H5.9375C5.42 15.625 5 15.205 5 14.6875C5 14.17 5.42 13.75 5.9375 13.75H13.75V5.9375C13.75 5.42 14.17 5 14.6875 5C15.205 5 15.625 5.42 15.625 5.9375V13.75H23.4375C23.955 13.75 24.375 14.17 24.375 14.6875Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plus_big.7208ffb6e172738eba69389978f56a0d.svg";
export { ForwardRef as ReactComponent };